var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"atom-padding"},[_c('div',{class:{ 'atom-gradient-background': true, active: _vm.isActive },on:{"click":_vm.handleClick}},[_c('div',{staticClass:"atom-project-slider-thumb",style:({ 'background-image': `url(${_vm.resourceUrl})` })},[_c('span',[_vm._v(_vm._s(_vm.title)+" "),_c('b',[_vm._v(_vm._s(_vm.subtitle))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }